<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">
              Nomor
              <i
                :class="
                  currentSort === 'nomor'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('klasifikasi')">
              Klasifikasi
              <i
                :class="
                  currentSort === 'klasifikasi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kode')">
              Kode
              <i
                :class="
                  currentSort === 'kode'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('sub_klasifikasi')">
              Sub Klasifikasi
              <i
                :class="
                  currentSort === 'sub_klasifikasi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('kualifikasi')">
              Kualifikasi
              <i
                :class="
                  currentSort === 'kualifikasi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              note
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.klasifikasi }}</td>
            <td>{{ list.kode }}</td>
            <td>{{ list.sub_klasifikasi }}</td>
            <td>{{ list.kualifikasi }}</td>
            <td>{{ list.updatedAt }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <SBUJK
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    SBUJK: () => import('@/views/MasterData/Edit/LegalDoc/SBUJK.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        klasifikasi: '',
        kode: '',
        sub_klasifikasi: '',
        kualifikasi: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          nomor: 1,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR101',
          sub_klasifikasi: 'Jasa Nasihat Dan Pra Desain Arsitektural',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          nomor: 2,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR102',
          sub_klasifikasi: 'Jasa Desain Arsitektural',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          nomor: 3,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR103',
          sub_klasifikasi:
            'Jasa Penilai Perawatan Dan Kelayakan Bangunan Gedung',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          nomor: 4,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR104',
          sub_klasifikasi: 'Jasa Desain Interior',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          nomor: 5,
          klasifikasi: 'Perencanaan Arsitektur',
          kode: 'AR105',
          sub_klasifikasi: 'Jasa Arsitektur Lainnya',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          nomor: 6,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE101',
          sub_klasifikasi: 'Jasa Nasehat Dan Konsultansi Rekayasa Teknik',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          nomor: 7,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE102',
          sub_klasifikasi:
            'Jasa Desain Rekayasa Untuk Konstruksi Pondasi Serta Struktur Bangunan',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          nomor: 8,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE103',
          sub_klasifikasi:
            'Jasa Desain Rekayasa Untuk Pekerjaan Teknik Sipil Air',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          nomor: 9,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE104',
          sub_klasifikasi:
            'Jasa Desain Rekayasa Untuk Pekerjaan Teknik Sipil Transportasi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          nomor: 10,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE105',
          sub_klasifikasi:
            'Jasa Desain Rekayasa Untuk Pekerjaan Mekanikal Dan Elektrikal Dalam Bangunan',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          nomor: 11,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE106',
          sub_klasifikasi:
            'Jasa Desain Rekayasa Untuk Proses Industrial Dan Produksi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          nomor: 12,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE107',
          sub_klasifikasi:
            'Jasa Nasehat Dan Konsultansi Jasa Rekayasa Konstruksi',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          nomor: 13,
          klasifikasi: 'Perencanaan Rekayasa',
          kode: 'RE108',
          sub_klasifikasi: 'Jasa Desain Rekayasa Lainnya',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          nomor: 14,
          klasifikasi: 'Perencanaan Penataan Ruang',
          kode: 'PR101',
          sub_klasifikasi: 'Jasa Perencanaan Dan Perancangan Perkotaan',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          nomor: 15,
          klasifikasi: 'Perencanaan Penataan Ruang',
          kode: 'PR102',
          sub_klasifikasi: 'Jasa Perencanaan Wilayah',
          kualifikasi: 'Kecil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        klasifikasi: data.klasifikasi,
        sub_klasifikasi: data.sub_klasifikasi,
        kode: data.kode,
        kualifikasi: data.kualifikasi,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    sbujkData() {
      const result = this.$store.state.mdDatabaseStore.sbujkData
      return result
    },
    sortedData() {
      return this.sbujkData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
